










import { Component, Vue } from 'vue-property-decorator';
import NavBar from '@/layouts/prescriber/components/NavBar.vue';
// @ts-ignore
import themeConfig from '../../../themeConfig.js';
import ServicesSelector from './components/ServicesSelector.vue';

@Component({
    components: {
        NavBar
    },
})
export default class PrescriberLayout extends Vue {
    routerTransition: string = themeConfig.routerTransition || 'none';
}
